import { Box } from '../Box';
import { useRef } from 'react';
import { interstateInputEventBuilder } from '../InterstateEvents';
import { ChevronDownIcon } from '../Icons';
import { boxStyleBuilder, chevronColorSelector, chevronSizeSelector } from './SelectInputStyles';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { ListBox } from '../ListBox';
import { ClickAwayListener, InputBase } from '@mui/material';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const SelectInputContainer = _ref => {
  let {
    displayDeselectOption = true,
    disabled,
    name,
    hasError,
    id,
    maxHeight,
    placeholder,
    onChange,
    options = [],
    optionsWidth = 'anchorWidth',
    readOnly,
    setOpen,
    setSelected,
    selected,
    open,
    validationStateType,
    size,
    label,
    onKeyDown,
    onFocus,
    onClickAway,
    ...rest
  } = _ref;
  const btnRef = useRef(undefined);
  const theme = useInterstateTheme();
  const handleClick = () => {
    if (disabled) {
      return;
    }
    setOpen(isOpen => !isOpen);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleItemClick = (disabled, onChange) => itemEvent => {
    const effectiveValue = typeof itemEvent.target?.value?.itemValue === 'number' ? itemEvent.target?.value?.itemValue.toString() : itemEvent.target?.value?.itemValue;
    if (!disabled) {
      setSelected(effectiveValue || '');
      setOpen(false);
      if (onChange) {
        onChange(interstateInputEventBuilder(name, effectiveValue, !hasError, itemEvent.domEvent, label, undefined, undefined));
      }
    }
  };
  /**
   * Build the item options for the drop down menu
   */
  const deselectOption = {
    value: undefined,
    label: undefined,
    name,
    disabled: false,
    onSelect: handleItemClick(Boolean(disabled), onChange),
    id: 'empty-option',
    'data-testid': 'empty-option'
  };
  let itemOptions = (options || []).map(option => {
    return {
      onSelect: handleItemClick(Boolean(disabled), onChange),
      ...option
    };
  });
  if (displayDeselectOption) {
    itemOptions = [deselectOption, ...itemOptions];
  }
  const selectedOption = options.find(o => selected === o.value && !o.groupHeader && !o.disabled);
  const effectiveDataTestId = rest['data-testid'] ? `select-input-options-${rest['data-testid']}` : 'select-input-options';
  const effectiveId = id ? `select-input-options-${id}` : 'select-input-options';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ClickAwayListener, {
      onClickAway: onClickAway,
      children: /*#__PURE__*/_jsx(Box, {
        sx: boxStyleBuilder(theme, disabled, readOnly, validationStateType, Boolean(open), size, selected),
        onClick: handleClick,
        tabIndex: 0,
        id: effectiveId,
        ref: btnRef,
        "data-testid": effectiveDataTestId,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '6px',
            '& > svg': {
              transform: open ? 'rotate(180deg)' : ''
            }
          },
          children: [/*#__PURE__*/_jsx(InputBase, {
            readOnly: true,
            value: selectedOption?.selectedLabel || selectedOption?.label || selectedOption?.value || '',
            placeholder: placeholder,
            id: id,
            fullWidth: true,
            slotProps: {
              input: {
                className: 'interstate-select-value'
              }
            }
          }), /*#__PURE__*/_jsx(ChevronDownIcon, {
            fontSize: chevronSizeSelector(size, theme),
            color: chevronColorSelector(validationStateType, disabled, theme)
          })]
        })
      })
    }), /*#__PURE__*/_jsx(ListBox, {
      onClose: handleClose,
      anchorEl: btnRef,
      open: Boolean(open),
      name: name,
      options: itemOptions,
      maxHeight: maxHeight,
      id: effectiveId,
      "data-testid": effectiveId,
      size: size,
      maxWidth: optionsWidth,
      selectedItem: selectedOption?.value,
      defaultOpenClickOverride: false
    })]
  });
};